var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84618 9.81626L2.4288 17.1753C2.07107 17.5303 1.4911 17.5303 1.1334 17.1753L0.26829 16.317C-0.0888313 15.9627 -0.0895181 15.3885 0.266763 15.0333L6.14516 9.17363L0.266763 3.31398C-0.0895181 2.95883 -0.0888313 2.38459 0.26829 2.03027L1.1334 1.17195C1.49114 0.817031 2.07111 0.817031 2.4288 1.17195L9.84614 8.53104C10.2039 8.88592 10.2039 9.46134 9.84618 9.81626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.c1c0a7cff1efd679ce25d980efe339ce.svg";
export { ForwardRef as ReactComponent };